import SignIn from "@views/public/sign-in/sign-in.vue";
const SignInStepTwo = () => import("@views/public/sign-in/sign-in-step-two.vue");
// const CompleteProfile = () => import("@views/public/sign-in/complete-profile.vue");
const RegistrationForm = () => import('@app/views/public/register/registration-form.vue');
const RegistrationCode = () => import('@app/views/public/register/registration-code.vue');
const RegistrationPassword = () => import('@app/views/public/register/registration-password.vue');
const RegistrationSuccess = () => import('@app/views/public/register/registration-success.vue');
const ResetStepOne = () => import('@app/views/public/reset-password/password-reset-step-one.vue');
const ResetStepTwo = () => import('@app/views/public/reset-password/password-reset-step-two.vue');
const ResetStepTwoTRR = () => import('@app/views/public/reset-password/password-reset-step-two-trr.vue');
const ResetStepThree = () => import('@app/views/public/reset-password/password-reset-step-three.vue');
const EmailVerification = () => import('@app/views/public/reset-password/email-verification.vue');
const EmailLandingPage = () => import("@views/app/dashboard/email-landing-page.vue");
const Peskovnik = () => import("@views/app/dashboard/sandbox.vue");

export const signInRoutes = [
    {
        component: SignIn,
        name: "sign_in",
        path: "prijava",
    },
    {
        component: SignInStepTwo,
        name: "sign_in_two",
        path: "koda"
    },
    // {
    //     component: CompleteProfile,
    //     name: "complete-profile",
    //     path: "dopolni-profil"
    // },
]

const registrationRoutes = [
    {
        name: "register",
        path: "registracija",
        redirect: {name: "register-start"},
        children: [
            {
                component: RegistrationForm,
                name: "register-start",
                path: "podatki",
            },
            {
                component: RegistrationCode,
                name: "registration-code",
                path: "koda",
            },
            {
                component: RegistrationPassword,
                name: "registration-password",
                path: "geslo",
            },
            {
                component: RegistrationSuccess,
                name: "registration-success",
                path: "nastavitev",
            }
        ]
    },
];

const resetPasswordRoutes = [
    {
        name: "ponastavitev",
        path: "ponastavitev",
        redirect: {name: "reset-phone"},
        children: [
            {
                component: ResetStepOne,
                name: "reset-phone",
                path: "telefon",
            },
            {
                component: ResetStepTwo,
                name: "reset-details",
                path: "podrobnosti",
            },
            {
                component: ResetStepTwoTRR,
                name: "reset-details-trr",
                path: "sprememba-gesla",
            },
            {
                component: EmailVerification,
                name: "email_verification",
                path: "email-verifikacija",
            },
            {
                component: ResetStepThree,
                name: "repeat-password",
                path: "novo-geslo/:passwordChangeRequestId",
                props: true
            }  
        ]
    } 
];

export const publicRoutes = [
    {
        children: [
            ...signInRoutes,
            ...registrationRoutes,
            ...resetPasswordRoutes,
            {
                component: EmailLandingPage,
                name: "email_page",
                path: "verifikacija-email/:id",
                props: true
            },
            {
                component: Peskovnik,
                name: "sandbox_testiranje_hgi",
                path: "peskovnik-testiranje-hgi-doo",
            }
        ],
        name: "public",
        path: "",
        redirect: "/prijava", // this is the default public view
    },
];